export default __webpack_public_path__ + "static/media/L2.jpg";